module.exports = __webpack_public_path__ + "img/Counter-and-cabinet.21710321.jpg";